import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import './assets/style/main.css'
import './assets/style/animation.scss'

import { createApp, createSSRApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/client'
import { useCounterStore } from './stores/counter'
import VueLazyload from 'vue-lazyload'

import TvbApp from './TvbApp.vue'
import router from './router'
import TvbSvgIcon from './components/TvbSvgIcon/index.vue'
import TvbImage from './components/TvbImage/index.vue'
import TvbButton from './components/TvbButton/index.vue'
import TvbRouterLink from './components/TvbRouterLink/index.vue'
import TvbAds from './components/TvbAds/index.vue'

import 'virtual:svg-icons-register'
import { useAppStore } from './stores/app'
import { useUserStore } from './stores/user'

export function makeApp() {
  const app = import.meta.env.SSR ? createSSRApp(TvbApp) : createApp(TvbApp)
  const store = createPinia()
  const head = createHead()
  const counter = useCounterStore(store)
  const appStore = useAppStore(store)
  const userStore = useUserStore(store)

  // 配置 NProgress，保持原有 TVB 渐变背景色
  NProgress.configure({
    showSpinner: false,
    trickleSpeed: 200,
    minimum: 0.1
  })

  app.use(store)
  app.use(router)
  app.use(head)
  app.use(VueLazyload, {
    error: '/image/img_header_logo@2x.png',
    loading: '/image/img_header_logo@2x.png'
  })

  app.component('tvb-svg-icon', TvbSvgIcon)
  app.component('tvb-image', TvbImage)
  app.component('tvb-button', TvbButton)
  app.component('tvb-router-link', TvbRouterLink)
  app.component('tvb-ads', TvbAds)

  // GPT 初始化：禁用初始加载，精确控制广告请求时机（SPA 模式）
  // setConfig 必须在 enableServices 之前调用，确保 display() 只注册不拉取
  if (!import.meta.env.SSR) {
    window.googletag = window.googletag || { cmd: [] }
    window.googletag.cmd.push(() => {
      // 迁移自 pubads().disableInitialLoad()，使用 setConfig 替代弃用方法
      window.googletag.setConfig({ disableInitialLoad: true })
      window.googletag.enableServices()
    })
  }

  router.beforeEach(async (to, from, next) => {
    counter.reset()
    await appStore.fetchConfig(import.meta.env.SSR ? null : window?.__INITIAL_STATE__?.app?.config)
    if (userStore.isLogin) await userStore.fetchUserInfo()
    !import.meta.env.SSR && NProgress.start()
    next()
  })

  if (!import.meta.env.SSR) {
    router.afterEach((to) => {
      NProgress.done()
      if (
        window.self !== window.top &&
        !['detail', 'vote', 'error404'].includes(to.name) &&
        !to.fullPath.includes('err_')
      ) {
        window.parent.location = to.fullPath
      }
    })
  }

  return {
    app,
    router,
    store,
    head
  }
}
